import { render } from "./invoices-list-modal.vue?vue&type=template&id=0ece49dc"
import script from "./invoices-list-modal.vue?vue&type=script&lang=js"
export * from "./invoices-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__